import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Dialog, NotificationService, SharedModule } from '@vendure/admin-ui/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'vdr-reject-reason-dialog',
    templateUrl: './reject-reason-dialog.component.html',
    styleUrls: ['./reject-reason-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: true,
    imports: [SharedModule],
})
export class RejectReasonDialogComponent implements Dialog, OnInit {
    form: FormGroup;
    resolveWith: (result?: any) => void;

    constructor(
        private formBuilder: FormBuilder,
        private notificationService: NotificationService,
    ) {}

    ngOnInit() {
        this.form = this.formBuilder.group({
            response: [null, Validators.required],
        });
    }

    send() {
        const formValues = this.form.value;

        const response = formValues.response;

        if (!response || response.trim().length === 0) {
            this.notificationService.error('Please enter a valid reason for rejection.');
        } else {
            this.resolveWith({
                response,
            });
        }
    }

    cancel() {
        this.resolveWith(false);
    }
}
